var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 153,
    viewBox: "0 0 100 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0829 12.0229L62.2672 3.43511L55.3843 8.01527L50.0886 0L44.8006 8.01527L37.9101 3.43511L35.102 12.0229L27.5781 9.73282L32.2863 26.0534H50.0886H67.8986L72.6067 9.73282L65.0829 12.0229Z",
    fill: "#CEB388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.112 18.458C39.5359 18.458 30.959 20.2443 30.959 22.4427V37.9924H69.265V22.4427C69.2421 20.2443 60.6728 18.458 50.112 18.458Z",
    fill: "#CEB388"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0885 41.9698C60.6665 41.9698 69.2415 40.1892 69.2415 37.9927C69.2415 35.7962 60.6665 34.0156 50.0885 34.0156C39.5106 34.0156 30.9355 35.7962 30.9355 37.9927C30.9355 40.1892 39.5106 41.9698 50.0885 41.9698Z",
    fill: "#4B4B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 123.885L50.0038 152.763L100 123.885V66.1296L50.0038 37.2441L0 66.1296V123.885Z",
    fill: "url(#paint0_linear_1729_104)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4283 108.766C54.3567 110.898 51.5846 111.964 48.112 111.964C44.6395 111.964 41.8599 110.898 39.7734 108.766C37.7018 106.619 36.666 103.898 36.666 100.603C36.666 99.1124 36.9343 97.8079 37.4708 96.6897C38.0073 95.5715 39.0208 93.9538 40.5112 91.8367L49.5651 78.9326H58.0826L50.124 90.2935C51.2865 90.3681 52.4192 90.6514 53.5221 91.1434C54.6249 91.6354 55.6309 92.3063 56.5401 93.1561C57.4492 93.9911 58.1795 95.0645 58.7309 96.3766C59.2823 97.6737 59.558 99.0975 59.558 100.648C59.558 103.928 58.5148 106.634 56.4283 108.766ZM48.112 105.322C49.4086 105.322 50.4743 104.882 51.3089 104.003C52.1584 103.123 52.5831 102.035 52.5831 100.738C52.5831 99.4553 52.1584 98.3744 51.3089 97.4948C50.4743 96.6002 49.4086 96.1529 48.112 96.1529C46.8005 96.1529 45.72 96.6002 44.8705 97.4948C44.0359 98.3744 43.6186 99.4553 43.6186 100.738C43.6186 102.035 44.0359 103.123 44.8705 104.003C45.72 104.882 46.8005 105.322 48.112 105.322Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_104",
    x1: 50,
    y1: 37.2441,
    x2: 50,
    y2: 152.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAAF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D99E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel6);
export default __webpack_public_path__ + "static/media/_level-6.5969ba4bc961068497ce538730633899.svg";
export { ForwardRef as ReactComponent };